import React, { useState, useEffect } from 'react';
import { FaKey, FaTimes } from 'react-icons/fa';
import Modal from './Modal';

const ResetPasswordModal = ({ open, onClose, onSubmit, username }) => {
  const [pw, setPw] = useState('');

  // Reset on open so a password typed for one user never persists into a
  // later open for a different user.
  useEffect(() => {
    if (open) setPw('');
  }, [open]);

  const pwLength = pw.length >= 8;
  const pwSpaces = pw === pw.trim();
  const canSubmit = pwLength && pwSpaces;
  return (
    <Modal open={open} onClose={onClose} title={`Reset Password for ${username}`}> 
      <div className="space-y-4">
        <input
          type="password"
          className="input-field"
          placeholder="Temporary password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
        />
        <div className="text-sm" aria-live="polite">
          <div>{pwLength ? '✓' : '✗'} At least 8 characters</div>
          <div>{pwSpaces ? '✓' : '✗'} No leading or trailing spaces</div>
        </div>
        <div className="flex flex-wrap justify-end gap-2 pt-2">
          <button onClick={onClose} className="btn-outline"><FaTimes />{' '}Cancel</button>
          <button onClick={() => onSubmit(pw)} disabled={!canSubmit} className="btn-primary disabled:opacity-50"><FaKey />{' '}Reset</button>
        </div>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;
